export default __webpack_public_path__ + "static/073-e2be7d3bfece5ddf59afb5f3c7b84c62.jpg";